import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=4f86cbf7&scoped=true"
import script from "./download.js?vue&type=script&lang=js&external"
export * from "./download.js?vue&type=script&lang=js&external"
import style0 from "./download.scss?vue&type=style&index=0&id=4f86cbf7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86cbf7",
  null
  
)

export default component.exports